function ThickWhiteNav() {

	var self							= this,
		w								= $( window ).width(),
		scrollTop						= 0,
		stickyBitTop					= 0,
		thickWhiteNavHeight				= 0,
		$thickWhiteNav					= $('.thick-white-nav'),
		thickWhiteNavHomeURL			= $('.thick-white-nav').data('home-url'),
		$thickWhiteNavItems				= $('.thick-white-nav .nav-item'),
		$corporateNavItems				= $('.corporate-nav .nav-item'),
		$thickWhiteNavDesktopLinks		= $(".thick-white-nav .desktop-nav a[aria-haspopup='true']"),
		$stickyBit						= $('.sticky-bit'),
		$basicContent					= $('.basic-content'),
		scrollTimeout					= null,
		thickWhiteNavItemsAnchorHeight	= $thickWhiteNavItems.find('a').css('padding-top');

	self.ready = function() {

		$('.thick-white-nav .nav-toggler').click( function(){
			$('.nav-collapse-area').collapse('hide');
		});

		if ( $thickWhiteNav.length ) {

			stickyBitTop		= $('.sticky-bit').offset().top;
			scrollTop			= $( window ).scrollTop();
			thickWhiteNavHeight	= $thickWhiteNav.outerHeight();

			self.setStickyBit( scrollTop );
			self.generateMobileNavs();

			// Listen for clicking on the iPad sizes, make a custom hide/show for that
			$('.thick-side-by-side-list').on('click', '.custom-quick-collapse-link', function( e ){
				e.preventDefault();

				var $this = $(this);

				$this.closest('.custom-quick-collapse-wrapper').find('.custom-quick-collapse-link').removeClass('active');
				$this.addClass('active');

				$this.closest('.custom-quick-collapse-wrapper').find('.custom-quick-collapse-area').addClass('hidden');
				$( $this.data('target') ).removeClass('hidden');
			});


			$('.auto-generated-xs-sm').on( 'click', '.nav-link', function( e ){
				e.preventDefault();

				var $this = $(this);

				if ( $this.attr('href') == '#' ) {
					$this.siblings('a').click();
				}
			});
		}

		if ( $thickWhiteNav.length && w >= BREAKPOINT_MD ) {

			$thickWhiteNavDesktopLinks.on('touchstart', function( event ){
				var $this = $(this);
				
				if ( !$this.hasClass('touched') ) {
					event.preventDefault();
					$thickWhiteNavDesktopLinks.removeClass('touched');
					$thickWhiteNavDesktopLinks.parent('li').removeClass('hover');
					$this.addClass('touched');
					$this.parent('li').addClass('hover');
				}
			});
		}
	};

	self.resize = function() {
		if ( $thickWhiteNav.length ) {
			
			w = $( window ).width();

			setTimeout(function(){
				stickyBitTop = $('.sticky-bit').offset().top;
				thickWhiteNavHeight = $thickWhiteNav.outerHeight();
			}, 100);

		}
	};

	self.scroll = function() {

		if ( $thickWhiteNav.length ) {

			scrollTop = $( window ).scrollTop();

			self.setStickyBit( scrollTop );

		}
	};

	self.setStickyBit = function ( scrollPosition ) {
		if ( scrollTimeout ) clearTimeout( scrollTimeout );
		scrollTimeout = setTimeout( function(){ 
			if ( !$stickyBit.hasClass( 'sticky' ) ) {
				stickyBitTop = $stickyBit.offset().top;
				thickWhiteNavHeight = $stickyBit.outerHeight( true );
			}
		}, 100 );
		
		if ( ( stickyBitTop + (thickWhiteNavItemsAnchorHeight.replace('px','') - 20) < scrollTop ) && ( w >= BREAKPOINT_MD ) ) {

			$stickyBit.addClass('sticky');
			$('.basic-content').css('padding-top', thickWhiteNavHeight);

		} else {

			$stickyBit.removeClass('sticky');
			$('.basic-content').css('padding-top', '0');

		}
	};

	self.generateMobileNavs = function () {

		var newHTMLXSSM = '',
			newHTMLMD = '',
			newHTMLSublinks = '',
			count = 1,
			firstActive = false;

		/* Main Nav */

		if ( thickWhiteNavHomeURL ) {
			newHTMLXSSM += '<li class="row mx-0"><a href="' + thickWhiteNavHomeURL + '" class="col">Home</a></li>';
			newHTMLMD += '<li class="row mx-0"><a href="' + thickWhiteNavHomeURL + '" class="col">Home</a></li>';
		}

		$thickWhiteNavItems.each( function(){
			var $this = $(this),
				$subNav = $this.find('ul');

			if ( $subNav.length != 0) {
				
				newHTMLXSSM += '' +
					'<li class="row mx-0">' +
					'	<a href="' + $this.children('a').attr('href') + '" class="col nav-link">' + $this.children('a').text() + '</a>' +
					'	<a href="#" class="col col-auto sub-nav-toggler collapsed d-flex align-items-center" data-toggle="collapse" data-target="#sub-nav-collapse-' + count + '" aria-controls="sub-nav-collapse-' + count + '" aria-expanded="false" aria-label="Toggle sub navigation"><span class="putnamicon putnamicon-angle-up"></span></a>' +
					'	<ul class="collapse col-12" id="sub-nav-collapse-' + count + '">';

				newHTMLMD += '' +
					'<li class="row mx-0">' +
					'	<a href="' + $this.children('a').attr('href') + '" class="col nav-link">' + $this.children('a').text() + '</a>';
				
				if ( !firstActive ) {
					newHTMLMD += '	<a href="#" class="col col-auto sub-nav-toggler custom-quick-collapse-link d-flex align-items-center active" data-toggle="custom-quick-collapse" data-target="#custom-quick-collapse-' + count + '" aria-controls="custom-quick-collapse-' + count + '" aria-expanded="true" aria-label="Toggle sub navigation"><span class="putnamicon putnamicon-angle-right"></span></a>';
					newHTMLSublinks += '' +
						'<div class="nav-collapse-area custom-quick-collapse-area" id="custom-quick-collapse-' + count + '">' +
						'	<ul class="main-nav-md-collapse-list">';
					firstActive = true;
				} else {
					newHTMLMD += '	<a href="#" class="col col-auto sub-nav-toggler custom-quick-collapse-link d-flex align-items-center" data-toggle="custom-quick-collapse" data-target="#custom-quick-collapse-' + count + '" aria-controls="custom-quick-collapse-' + count + '" aria-expanded="false" aria-label="Toggle sub navigation"><span class="putnamicon putnamicon-angle-right"></span></a>';
					newHTMLSublinks += '' +
						'<div class="nav-collapse-area custom-quick-collapse-area hidden" id="custom-quick-collapse-' + count + '">' +
						'	<ul class="main-nav-md-collapse-list">';
				}

				$subNav.find('li').each( function(){
					var $this = $(this);

					newHTMLXSSM		+= '		<li class="row mx-0"><a href="' + $this.children('a').attr('href') + '" class="col">' + $this.children('a').text() + '</a></li>';
					newHTMLSublinks	+= '		<li class="row mx-0"><a href="' + $this.children('a').attr('href') + '" class="col">' + $this.children('a').text() + '</a></li>';
				});

				newHTMLXSSM += '' +
					'	</ul>' +
					'</li>';

				newHTMLMD += '' +
					'</li>';

				newHTMLSublinks += '' +
					'	</ul>' +
					'</div>';

			} else {
				newHTMLXSSM	+= '<li class="row mx-0"><a href="' + $this.children('a').attr('href') + '" class="col">' + $this.children('a').text() + '</a></li>';
				newHTMLMD	+= '<li class="row mx-0"><a href="' + $this.children('a').attr('href') + '" class="col">' + $this.children('a').text() + '</a></li>';
			}

			count++;
		});

		$('#main-nav-collapse .auto-generated-xs-sm').prepend( newHTMLXSSM );
		$('#main-nav-collapse-md .auto-generated-md').prepend( newHTMLMD );
		$('#main-nav-collapse-md .auto-generated-md-sublinks').prepend( newHTMLSublinks );

		/* Corporate nav */

		newHTMLXSSM = '';
		newHTMLMD = '';
		newHTMLSublinks = '';
		count = 1;
		firstActive = false;

		$corporateNavItems.each( function(){
			var $this = $(this),
				$subNav = $this.find('.dropdown-menu');

			if ( $subNav.length != 0) {
				
				newHTMLXSSM += '' +
					'<li class="row mx-0">' +
					'	<a href="' + $this.children('a').attr('href') + '" class="col nav-link">' + $this.children('a').text() + '</a>' +
					'	<a href="#" class="col col-auto sub-nav-toggler collapsed d-flex align-items-center" data-toggle="collapse" data-target="#corporate-nav-collapse-' + count + '" aria-controls="corporate-nav-collapse-' + count + '" aria-expanded="false" aria-label="Toggle sub navigation"><span class="putnamicon putnamicon-angle-up"></span></a>' +
					'	<ul class="collapse col-12" id="corporate-nav-collapse-' + count + '">';

				newHTMLMD += '' +
					'<li class="row mx-0">' +
					'	<a href="' + $this.children('a').attr('href') + '" class="col nav-link">' + $this.children('a').text() + '</a>';

				if ( !firstActive ) {
					newHTMLMD += '	<a href="#" class="col col-auto sub-nav-toggler custom-quick-collapse-link d-flex align-items-center active" data-toggle="custom-quick-collapse" data-target="#custom-quick-collapse-corporate-' + count + '" aria-controls="custom-quick-collapse-corporate-' + count + '" aria-expanded="true" aria-label="Toggle sub navigation"><span class="putnamicon putnamicon-angle-right"></span></a>';
					newHTMLSublinks += '' +
						'<div class="nav-collapse-area custom-quick-collapse-area" id="custom-quick-collapse-corporate-' + count + '">' +
						'	<ul class="main-nav-md-collapse-list">';
					firstActive = true;
				} else {
					newHTMLMD += '	<a href="#" class="col col-auto sub-nav-toggler custom-quick-collapse-link d-flex align-items-center" data-toggle="custom-quick-collapse" data-target="#custom-quick-collapse-corporate-' + count + '" aria-controls="custom-quick-collapse-corporate-' + count + '" aria-expanded="false" aria-label="Toggle sub navigation"><span class="putnamicon putnamicon-angle-right"></span></a>';
					newHTMLSublinks += '' +
						'<div class="nav-collapse-area custom-quick-collapse-area hidden" id="custom-quick-collapse-corporate-' + count + '">' +
						'	<ul class="main-nav-md-collapse-list">';
				}

				$subNav.find('a').each( function(){
					var $this = $(this);

					newHTMLXSSM		+= '		<li class="row mx-0"><a href="' + $this.attr('href') + '" class="col">' + $this.text() + '</a></li>';
					newHTMLSublinks	+= '		<li class="row mx-0"><a href="' + $this.attr('href') + '" class="col">' + $this.text() + '</a></li>';
				});

				newHTMLXSSM += '' +
					'	</ul>' +
					'</li>';

				newHTMLMD += '' +
					'</li>';

				newHTMLSublinks += '' +
					'	</ul>' +
					'</div>';

			} else {
				newHTMLXSSM	+= '<li class="row mx-0"><a href="' + $this.children('a').attr('href') + '" class="col">' + $this.children('a').text() + '</a></li>';
				newHTMLMD	+= '<li class="row mx-0"><a href="' + $this.children('a').attr('href') + '" class="col">' + $this.children('a').text() + '</a></li>';
			}

			count++;
		});

		$('#corporate-nav-collapse .auto-generated-xs-sm').prepend( newHTMLXSSM );
		$('#corporate-nav-collapse-md .auto-generated-md').prepend( newHTMLMD );
		$('#corporate-nav-collapse-md .auto-generated-md-sublinks').prepend( newHTMLSublinks );
	};

	ApplicationObject.call( this );
}

ThickWhiteNav.prototype = Object.create( ApplicationObject.prototype );